import { AsyncPipe, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, Injectable, TemplateRef, ChangeDetectorRef, forwardRef, Directive } from '@angular/core';
import { tuiIsString, tuiCreateToken, tuiProvideOptions } from '@taiga-ui/cdk/utils/miscellaneous';
import { tuiButtonOptionsProvider, TuiButton } from '@taiga-ui/core/components/button';
import { TuiFormatDatePipe } from '@taiga-ui/core/pipes/format-date';
import { TUI_CLOSE_WORD, TUI_COMMON_ICONS, TUI_ANIMATIONS_SPEED } from '@taiga-ui/core/tokens';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tuiIfMap } from '@taiga-ui/cdk/observables';
import { injectContext, PolymorpheusOutlet, PolymorpheusTemplate } from '@taiga-ui/polymorpheus';
import { Subject } from 'rxjs';
import { TuiPopoverService } from '@taiga-ui/cdk/services';
import { TUI_ALERTS } from '@taiga-ui/core/components/alert';
import { tuiFadeIn, tuiSlideInRight, tuiHeightCollapse } from '@taiga-ui/core/animations';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import { TuiLink } from '@taiga-ui/core/components/link';
import { tuiToAnimationOptions } from '@taiga-ui/core/utils/miscellaneous';
const _c0 = [[["img"]], [["tui-svg"], ["tui-icon"]], "*", [["", "tuiButton", ""]], [["", "tuiLink", ""]]];
const _c1 = ["img", "tui-svg,tui-icon", "*", "[tuiButton]", "[tuiLink]"];
function TuiPushComponent_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function TuiPushComponent_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("border-radius", 100, "%");
    i0.ɵɵproperty("iconStart", ctx_r1.icons.close);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r1.closeWord$), "\n");
  }
}
function TuiPushComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
    i0.ɵɵpipe(1, "tuiFormatDate");
    i0.ɵɵpipe(2, "async");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.isString(ctx_r1.timestamp) ? ctx_r1.timestamp : i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r1.timestamp)));
  }
}
function TuiPushAlert_tui_push_0_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r1.context.image, i0.ɵɵsanitizeUrl);
  }
}
function TuiPushAlert_tui_push_0_tui_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-icon", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("color", ctx_r1.context.iconColor);
    i0.ɵɵproperty("icon", ctx_r1.context.icon);
  }
}
function TuiPushAlert_tui_push_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
  }
  if (rf & 2) {
    const text_r3 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("innerHTML", text_r3, i0.ɵɵsanitizeHtml);
  }
}
function TuiPushAlert_tui_push_0_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function TuiPushAlert_tui_push_0_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.context.$implicit.next(ctx_r1.context.buttons[0] || ""));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.context.buttons[0], " ");
  }
}
function TuiPushAlert_tui_push_0_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function TuiPushAlert_tui_push_0_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.context.$implicit.next(ctx_r1.context.buttons[ctx_r1.context.buttons.length - 1] || ""));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.context.buttons[ctx_r1.context.buttons.length - 1], " ");
  }
}
function TuiPushAlert_tui_push_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-push", 2);
    i0.ɵɵlistener("close", function TuiPushAlert_tui_push_0_Template_tui_push_close_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.context.$implicit.complete());
    });
    i0.ɵɵtemplate(1, TuiPushAlert_tui_push_0_img_1_Template, 1, 1, "img", 3)(2, TuiPushAlert_tui_push_0_tui_icon_2_Template, 1, 3, "tui-icon", 4)(3, TuiPushAlert_tui_push_0_div_3_Template, 1, 1, "div", 5)(4, TuiPushAlert_tui_push_0_button_4_Template, 2, 1, "button", 6)(5, TuiPushAlert_tui_push_0_button_5_Template, 2, 1, "button", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("heading", ctx_r1.context.heading)("timestamp", ctx_r1.context.timestamp)("type", ctx_r1.context.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.context.image);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.context.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r1.context.content)("polymorpheusOutletContext", ctx_r1.context);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.context.buttons.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.context.buttons.length);
  }
}
function TuiPushAlert_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiPushAlert_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiPushAlert_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r1.context.content);
  }
}
let TuiPushComponent = /*#__PURE__*/(() => {
  class TuiPushComponent {
    constructor() {
      this.isString = tuiIsString;
      this.closeWord$ = inject(TUI_CLOSE_WORD);
      this.icons = inject(TUI_COMMON_ICONS);
      this.heading = '';
      this.type = '';
      this.lines = 2;
      this.timestamp = '';
      this.close = new EventEmitter();
    }
    static {
      this.ɵfac = function TuiPushComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiPushComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiPushComponent,
        selectors: [["tui-push"]],
        hostVars: 2,
        hostBindings: function TuiPushComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("--t-lines", ctx.lines);
          }
        },
        inputs: {
          heading: "heading",
          type: "type",
          lines: "lines",
          timestamp: "timestamp"
        },
        outputs: {
          close: "close"
        },
        features: [i0.ɵɵProvidersFeature([tuiButtonOptionsProvider({
          size: 's',
          appearance: 'secondary'
        })])],
        ngContentSelectors: _c1,
        decls: 17,
        vars: 4,
        consts: [[1, "t-image"], ["appearance", "", "size", "xs", "tuiIconButton", "", "type", "button", "class", "t-close", 3, "iconStart", "border-radius", "click", 4, "ngIf"], [1, "t-top"], [1, "t-icon"], ["class", "t-time", 3, "textContent", 4, "ngIf"], ["automation-id", "tui-push__heading", 1, "t-heading"], [1, "t-content"], [1, "t-actions"], [1, "t-button"], [1, "t-link"], ["appearance", "", "size", "xs", "tuiIconButton", "", "type", "button", 1, "t-close", 3, "click", "iconStart"], [1, "t-time", 3, "textContent"]],
        template: function TuiPushComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, TuiPushComponent_button_2_Template, 3, 6, "button", 1);
            i0.ɵɵelementStart(3, "div", 2)(4, "span", 3);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(6);
            i0.ɵɵtemplate(7, TuiPushComponent_span_7_Template, 3, 5, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "h3", 5);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 6);
            i0.ɵɵprojection(11, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 7)(13, "span", 8);
            i0.ɵɵprojection(14, 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "span", 9);
            i0.ɵɵprojection(16, 4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.close.observed);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", ctx.type, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.timestamp);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.heading, "\n");
          }
        },
        dependencies: [AsyncPipe, NgIf, TuiButton, TuiFormatDatePipe],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;inline-size:22.5rem;max-inline-size:100%;box-sizing:border-box;padding:1.25rem 1.25rem .25rem;overflow:hidden;font:var(--tui-font-text-m);border-radius:var(--tui-radius-xl);background:var(--tui-background-elevation-3);box-shadow:var(--tui-shadow-small)}.t-image[_ngcontent-%COMP%]{display:flex;flex-direction:column;max-block-size:10.625rem;overflow:hidden;margin:-1.25rem -1.25rem 1.25rem}.t-close[_ngcontent-%COMP%]{position:absolute;top:.75rem;right:.75rem;color:#0000008a;background:#f2f2f252;-webkit-backdrop-filter:blur(1rem);backdrop-filter:blur(1rem)}.t-top[_ngcontent-%COMP%]{display:flex;align-items:center;font:var(--tui-font-text-s);color:var(--tui-text-secondary)}.t-icon[_ngcontent-%COMP%]{block-size:1.25rem;margin-right:.5rem;transform:scale(.833);transform-origin:top left;color:var(--tui-text-action)}.t-time[_ngcontent-%COMP%]:before{content:\"\\2022\";display:inline-block;inline-size:1rem;text-align:center}.t-heading[_ngcontent-%COMP%]{line-height:1.25rem;font-weight:700;margin:.75rem 0 .25rem}.t-heading[_ngcontent-%COMP%], .t-content[_ngcontent-%COMP%]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:var(--t-lines);word-break:break-word;overflow:hidden}.t-actions[_ngcontent-%COMP%]{display:flex;align-items:center;font:var(--tui-font-text-s)}.t-button[_ngcontent-%COMP%]:not(:empty){margin:.75rem .75rem .75rem 0}.t-link[_ngcontent-%COMP%]{margin:.75rem 0}.t-link[_ngcontent-%COMP%]:empty{margin:.5rem}"],
        changeDetection: 0
      });
    }
  }
  return TuiPushComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_PUSH_DEFAULT_OPTIONS = {
  heading: '',
  type: '',
  timestamp: '',
  image: '',
  icon: '',
  iconColor: '',
  buttons: []
};
/**
 * Default parameters for Push component
 */
const TUI_PUSH_OPTIONS = tuiCreateToken(TUI_PUSH_DEFAULT_OPTIONS);
function tuiPushOptionsProvider(options) {
  return tuiProvideOptions(TUI_PUSH_OPTIONS, options, TUI_PUSH_DEFAULT_OPTIONS);
}
let TuiPushAlert = /*#__PURE__*/(() => {
  class TuiPushAlert {
    constructor() {
      this.options = tuiToAnimationOptions(inject(TUI_ANIMATIONS_SPEED));
      this.context = injectContext();
    }
    get isDirective() {
      return this.context.content instanceof TuiPushDirective;
    }
    static {
      this.ɵfac = function TuiPushAlert_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiPushAlert)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiPushAlert,
        selectors: [["ng-component"]],
        hostAttrs: ["role", "alert"],
        hostVars: 3,
        hostBindings: function TuiPushAlert_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@tuiFadeIn", ctx.options)("@tuiSlideInRight", ctx.options)("@tuiHeightCollapse", ctx.options);
          }
        },
        decls: 3,
        vars: 2,
        consts: [["directive", ""], [3, "heading", "timestamp", "type", "close", 4, "ngIf", "ngIfElse"], [3, "close", "heading", "timestamp", "type"], ["alt", "", 3, "src", 4, "ngIf"], [3, "icon", "color", 4, "ngIf"], [3, "innerHTML", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], ["tuiButton", "", "type", "button", 3, "click", 4, "ngIf"], ["tuiLink", "", "type", "button", 3, "click", 4, "ngIf"], ["alt", "", 3, "src"], [3, "icon"], [3, "innerHTML"], ["tuiButton", "", "type", "button", 3, "click"], ["tuiLink", "", "type", "button", 3, "click"], [4, "polymorpheusOutlet"]],
        template: function TuiPushAlert_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TuiPushAlert_tui_push_0_Template, 6, 9, "tui-push", 1)(1, TuiPushAlert_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const directive_r6 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.isDirective)("ngIfElse", directive_r6);
          }
        },
        dependencies: [NgIf, PolymorpheusOutlet, TuiButton, TuiIcon, TuiLink, TuiPushComponent],
        styles: ["[_nghost-%COMP%]{max-inline-size:calc(100% - 2rem);margin:0 1rem 1rem auto}[_nghost-%COMP%]:first-child{margin-top:auto}"],
        data: {
          animation: [tuiFadeIn, tuiSlideInRight, tuiHeightCollapse]
        },
        changeDetection: 0
      });
    }
  }
  return TuiPushAlert;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiPushService = /*#__PURE__*/(() => {
  class TuiPushService extends TuiPopoverService {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiPushService_BaseFactory;
        return function TuiPushService_Factory(__ngFactoryType__) {
          return (ɵTuiPushService_BaseFactory || (ɵTuiPushService_BaseFactory = i0.ɵɵgetInheritedFactory(TuiPushService)))(__ngFactoryType__ || TuiPushService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TuiPushService,
        factory: () => (() => new TuiPushService(TUI_ALERTS, TuiPushAlert, inject(TUI_PUSH_OPTIONS)))(),
        providedIn: 'root'
      });
    }
  }
  return TuiPushService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiPushDirective = /*#__PURE__*/(() => {
  class TuiPushDirective extends PolymorpheusTemplate {
    constructor() {
      super(inject(TemplateRef), inject(ChangeDetectorRef));
      this.push = inject(forwardRef(() => TuiPushService));
      this.show$ = new Subject();
      this.show$.pipe(tuiIfMap(() => this.push.open(this)), takeUntilDestroyed()).subscribe();
    }
    set tuiPush(show) {
      this.show$.next(show);
    }
    static {
      this.ɵfac = function TuiPushDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiPushDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiPushDirective,
        selectors: [["ng-template", "tuiPush", ""]],
        inputs: {
          tuiPush: "tuiPush"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TuiPushDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TuiPush = [TuiPushComponent, TuiPushAlert, TuiPushDirective];

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_PUSH_DEFAULT_OPTIONS, TUI_PUSH_OPTIONS, TuiPush, TuiPushAlert, TuiPushComponent, TuiPushDirective, TuiPushService, tuiPushOptionsProvider };
